export const CustomlinksInteracted = {
  "eventlabel": "",
  "eventCategory": "",
  "eventAction": "",
  "pageName": "",
  "pageUrl": "",
  "pageCategory": "",
};